import APIService from './apiService';
import { User } from '../types';
import LocalStorageService from './localStorageService';

export const ErrorMessages = {
  unhandled: 'Received unhandled error from the server',
  invalidCredentials: 'Invalid username and/or password',
  usernameTaken: 'Username taken',
  emailTaken: 'Email taken'
};

export default class UserService {
  private apiService: APIService;
  private localStorageService: LocalStorageService;

  constructor() {
    this.apiService = new APIService();
    this.localStorageService = new LocalStorageService();
  }

  public signUserUp(email: string, password: string, username: string): Promise<User> {
    const requestBody = {
      email,
      password,
      username
    };

    return this.apiService.postRequest('/auth/signup', requestBody)
      .then((response: Response) => {
        if (!response.ok && response.status !== 403) {
          throw new Error(ErrorMessages.unhandled);
        }

        return response.json();
      })
      .then((responseObject) => {
        if (responseObject.error) {
          throw new Error(responseObject.error);
        }

        this.localStorageService.setAccessToken(responseObject.token);
        this.localStorageService.setLocalUser(responseObject.user);
        return responseObject.user;
      });
  }

  public logUserIn(email: string, password: string): Promise<User> {
    const requestBody = {
      email,
      password
    };

    return this.apiService.postRequest('/auth/login', requestBody)
      .then((response: Response) => {
        if (!response.ok && response.status !== 403) {
          throw new Error(ErrorMessages.unhandled);
        }

        return response.json();
      })
      .then((responseObject) => {
        if (responseObject.error) {
          throw new Error(responseObject.error);
        }

        this.localStorageService.setAccessToken(responseObject.token);
        this.localStorageService.setLocalUser(responseObject.user);
        return responseObject.user;
      });
  }

  public logUserOut(): Promise<void> {
    this.localStorageService.removeAccessToken();
    this.localStorageService.removeLocalUser();
    return Promise.resolve();
  }

  public fetchUsers(): Promise<User[]> {
    return this.apiService.getRequest('/users')
      .then((response) => {
        if (!response.ok) {
          throw new Error(ErrorMessages.unhandled);
        }

        return response.json();
      })
      .then((responseObject) => {
        return responseObject.users;
      });
  }

  public getUserByID(id: string): Promise<User> {
    const endpoint = `/users/${id}`;

    return this.apiService.getRequest(endpoint)
      .then((response) => {
        if (!response.ok) {
          throw new Error(ErrorMessages.unhandled);
        }

        return response.json();
      })
      .then((responseObject) => {
        return responseObject.user;
      });
  }
}
